import { Pipe, PipeTransform } from '@angular/core';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';


@Pipe({
  name: 'sales-monitoring-visit-pipe'
})

export class SalesMonitoringVisitPipe implements PipeTransform {
  
  constructor(
      protected leanUtilsService        : LeanUtilsService){
    }


  transform(smv: Visit, field: string): any {

    let result = '';

    if (field == 'startTime'){
      if (smv.startTime){
        let startTime = this.leanUtilsService.timePipe(smv.startTime);
        let endTime = this.leanUtilsService.timePipe(smv.endTime);

        result = "<div class='sm-list-time'>" + startTime + "<span class='sm-list-time'>" + endTime + "</span> </div>";
      }
     } 

     if (field == 'achievedAmount'){
      if (smv.achievedAmount){
        let achievedAmount = Math.round(smv.achievedAmount * 100) / 100;
        result = "<div class='sm-list-amount'>" + achievedAmount + "</div>";
       }
     } 

     if (field == 'achievedVolume'){
      if (smv.achievedVolume){
        let achievedVolume = Math.round(smv.achievedVolume * 100) / 100;
        result = "<div class='sm-list-volume'>" + achievedVolume + "</div>";
       }
     } 

     if (field == 'visitResultName'){
      if (smv.visitResultName && (smv.visitResultName != "OK")){
        result = "<div class='sm-list-nsr'>" + smv.visitResultName + "</div>";
       }
     } 

     if (field == 'positionMismatch'){
      if (! smv.actualRank){
          return '';
      }
      
      if ( (! smv.partner.longitude) && ((! smv.partner.latitude))){
        return '';
      }

      if (smv.positionMismatch){
          result = "<img class='sm-list-gps-compliance' src='assets/images/icons/rejected.png'>" ;
       } else {
          result = "<img class='sm-list-gps-compliance' src='assets/images/icons/checked.png'>" ;
       }
     } 

     if (field == 'actualRank'){
      if (smv.actualRank) {
        if (smv.actualRank != smv.plannedRank){
          result = "<div class='sm-list-nsr'>" + smv.actualRank + "</div>";
         } else {
          result = ''+smv.actualRank;
         }
      }
     } 
     
    return result;
  }
}